import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "yanki",
  name: "Yankı",
  tagline: "Sırayı dinle, işaretleri tekrarla. Ters yankı seviyelerinde sondan başa ver.",
  inspiredBy: "Simon / dizisel bellek oyunları",
  secondLayer: "6. seviyeden sonra her 3. seviye ters yankı: dizi sondan başa girilir. Paylaşılan link arkadaşına aynı seviyeyi açar.",
  accent: "#2ec4b6",
  status: "lab",
};
